module.exports = __webpack_public_path__ + "static/teachersmutualbank-stats-40de00c1ebdb02799d5cee7d3bed4166.png";